var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-group"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.url)?_c('span',{staticClass:"link",on:{"click":_vm.toggleUrl}},[_vm._v("查看全部"),_c('i',{staticClass:"icon icon-more"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }